import { AxiosInstance } from 'axios';

import { insertId } from '../insertId';
import { toResponse } from '../genericToResponse';
import { cancellable } from '../cancellable';

export default (api: AxiosInstance, url: string) => (
  id: number,
  shortlink: string
) => {
  const urlWithId = insertId(url, id);
  return cancellable<{ preview: string; message: string }>(
    (cancelOptions: any) =>
      api.post(
        urlWithId,
        {
          url: shortlink,
        },
        cancelOptions
      ),
    toResponse
  );
};



// WEBPACK FOOTER //
// ./src/services/api/shortlink/create.ts